<script setup lang="ts">
import type { Category } from '@/types/api/api-v3/category'

import MainCategoryCard from '@/components/Main/Category/MainCategoryCard.vue'
import MainCategoryLink from '@/components/Main/Category/MainCategoryLink.vue'

type Props = {
  simpleCategories: Category[]
  isCategoryPage?: boolean
}

defineProps<Props>()

const sale = ref<Category>({
  icon: '/main-category-sale.webp',
  image: '/main-category-sale.webp',
  is_filter: false,
  is_japan: false,
  name: 'Акции',
  path: '/sales/',
  slug: 'sales',
})
</script>

<template>
  <nav
    class="category-list"
    itemscope
    itemtype="http://schema.org/SiteNavigationElement"
  >
    <!-- Список категорий для страницы отдельной категории  -->
    <the-slider
      v-if="isCategoryPage"
      class="category-list__slider"
      overlay="sm"
      :space-between="8"
      :slide-width="60"
      :ripple="false"
      :snap="false"
      is-different-width
    >
      <!-- Захардкоженная категория акции на фронте-->
      <main-category-link :category="sale" />

      <main-category-link
        v-for="(category, index) in simpleCategories"
        :key="index"
        :category="category"
      />
    </the-slider>

    <!-- Список категорий для главной страницы  -->
    <section v-else class="category-list__cards">
      <!-- Захардкоженная категория акции на фронте-->
      <main-category-card class="category-list__card" :category="sale" />

      <main-category-card
        v-for="(category, index) in simpleCategories"
        :key="index"
        :category="category"
        class="category-list__card"
      />
    </section>
  </nav>
</template>

<style lang="scss" scoped>
.category-list {
  overflow: hidden;

  &__slider {
    padding: 0 8px;
  }

  &__cards {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;

    @include media('>=portrait-phone') {
      grid-template-columns: repeat(4, 1fr);
      gap: 16px;
    }

    @include media('>=tablet') {
      grid-template-columns: repeat(5, 1fr);
    }

    @include media('>=desktop-mini') {
      grid-template-columns: repeat(6, 1fr);
    }
  }
}
</style>
